import { ChipProps } from '@mui/material/Chip'
import { ReactElement } from 'react'

type ParticipantStatusChipProps = {
  label: string
  sx: ChipProps['sx']
  icon: ReactElement
}

export const getParticipantStatusChip = (status: string): ParticipantStatusChipProps => {
  switch (status) {
    case 'PARTICIPANT_STATUS_ACCEPTED':
      return {
        label: 'Accepted',
        sx: {
          backgroundColor: '#DCFCE7',
          color: '#155724',
          fontWeight: 600,
        },
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M10 3L4.5 8.5L2 6"
              stroke="#22C55E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
      }
    case 'PARTICIPANT_STATUS_FORCE_ADDED':
      return {
        label: 'Force added',
        sx: {
          backgroundColor: '#DCFCE7',
          color: '#155724',
          fontWeight: 600,
        },
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M6 2.5V9.5M2.5 6H9.5"
              stroke="#22C55E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
      }

    case 'PARTICIPANT_STATUS_INVITED':
      return {
        label: 'Invited',
        sx: {
          backgroundColor: '#EEF2FF',
          color: '#1D4ED8',
          fontWeight: 600,
          px: 1,
          gap: '6px',
        },
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
            <circle cx="4" cy="4" r="3" fill="#3B82F6" />
          </svg>
        ),
      }

    case 'PARTICIPANT_STATUS_DECLINED':
      return {
        label: 'Declined',
        sx: {
          backgroundColor: '#F5F5F5',
          color: '#404040',
          fontWeight: 600,
        },
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M4.5 7L2 4.5M2 4.5L4.5 2M2 4.5H8C8.53043 4.5 9.03914
               4.71071 9.41421 5.08579C9.78929 5.46086 10 5.96957 10 6.5V10"
              stroke="#737373"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
      }

    case 'PARTICIPANT_STATUS_BLOCKED':
      return {
        label: 'Blocked',
        sx: {
          backgroundColor: '#f8d7da',
          color: '#721c24',
          fontWeight: 600,
        },
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M9 3L3 9M3 3L9 9"
              stroke="#EF4444"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
      }

    case 'PARTICIPANT_STATUS_CANCELLED':
      return {
        label: 'Cancelled',
        sx: {
          backgroundColor: '#F5F5F5',
          color: '#404040',
          fontWeight: 600,
        },
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M9 3L3 9M3 3L9 9"
              stroke="#404040"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
      }

    case 'PARTICIPANT_STATUS_DELETED':
      return {
        label: 'Deleted',
        sx: {
          backgroundColor: '#f8d7da',
          color: '#721c24',
          fontWeight: 600,
        },
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M9 3L3 9M3 3L9 9"
              stroke="#EF4444"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
      }

    default:
      return {
        label: status,
        sx: {
          backgroundColor: '#f8d7da',
          color: '#721c24',
          fontWeight: 600,
        },
        icon: <></>,
      }
  }
}
